import { showGlobalDialogError } from "../components/error";
import { apiClient } from "./apiClient.services";
import { stringDate } from "../utils/utilityFunctions";

function getAuthData() {
	return {
		businessId: localStorage.getItem("businessId"),
	};
}

export const GetMarketplaceReport = async (value) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/reports/seller/marketplace-payment${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetTransactionReport = async (value) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/reports/seller/transactions${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetVepayFeeReport = async (value) => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/reports/seller/vepay-fees${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetTransactionBreakdown = async (transactionType, startDate, endDate, pageNumber, pageSize) => {
	const datetostring = stringDate([startDate, endDate]);
	const { businessId } = getAuthData();

	if (datetostring[0] === 'Invalid date') {
		datetostring[0] = datetostring[1]
	}

	if (datetostring[1] === 'Invalid date') {
		datetostring[1] = datetostring[0]
	}

	let url;
	if (pageNumber !== undefined && pageSize !== undefined) {
		url = `/core/daily-summary-drill-page?start=${datetostring[0]}&end=${datetostring[1]}&type=${transactionType}&pageNumber=${pageNumber}&pageSize=${pageSize}`;
	} else {
		url = `/core/daily-summary-drill?start=${datetostring[0]}&end=${datetostring[1]}&type=${transactionType}`;
	}

	if (localStorage.getItem("businessId")) {
		url += `&businessId=${businessId}`;
	}

	try {
		return await apiClient(url);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetGeneratedReport = async (value) => {
	const { businessId } = getAuthData();
	try {
		let result = await apiClient(`/llm/custom-report${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`, {
			method: "POST",
			body: value
		});
		return { response: { ok: !!result }, result };
	} catch (e) {
		throw e;
	}
}

export const GetMarketplaceOverview = async (startDate, endDate) => {
	const { businessId } = getAuthData();
	try {
		let params = new URLSearchParams();
		if (startDate) params.append("startDate", startDate);
		if (endDate) params.append("endDate", endDate);
		if (localStorage.getItem("businessId")) params.append("businessId", businessId);

		return await apiClient(`/dashboard/overviews/seller/marketplace-overview?${params.toString()}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetSellerBalanceSummary = async () => {
	const { businessId } = getAuthData();
	try {
		return await apiClient(`/core/accounts/seller-balance-summary${localStorage.getItem("businessId") ? `?businessId=${businessId}` : ''}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}

export const GetDailySummary = async (upto) => {
	const { businessId } = getAuthData();
	try {
		let params = new URLSearchParams();
		if (upto) params.append("upto", upto);
		if (localStorage.getItem("businessId")) params.append("businessId", businessId);

		return await apiClient(`/trans/daily-summary?${params.toString()}`);
	} catch (e) {
		showGlobalDialogError();
		throw e;
	}
}